import { AddVehicleAction } from "./../../../ngxs-store/vehicles-store/vehicles.action";
import { VehicleModel } from "@core/services/api.service";
import { UntypedFormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Actions, Store, ofActionSuccessful } from "@ngxs/store";
import {
    Component,
    Input,
    Inject,
    ChangeDetectorRef,
} from "@angular/core";
import { GetTourByIdAction } from "@ngxs-store/managed-tour-store/managed-tour.actions";
import { AddCustomerContactPersonAction, AddCustomerContactPersonSuccessAction } from "@ngxs-store/customer-store/customer.actions";
import { UpdateCarrierContactEmailAction, UpdateCarrierContactEmailSuccessAction } from "@ngxs-store/customer-store/customer.actions";
import { AddTrailerRegByTourIdAction, AddTrailerRegByTourIdSuccessAction } from "@ngxs-store/managed-tour-store/managed-tour.actions";

@Component({
    selector: "app-add-vehicle-dialog",
    templateUrl: "./add-vehicle-dialog.component.html",
})
export class AddVehicleDialogComponent {
    @Input() vehicles: VehicleModel[];
    @Input() isLoading: boolean;
    @Input() isMobileMode: boolean;
    @Input() id: number;
    @Input() isEmail: boolean = false;
    @Input() isCarrierEmail: boolean = false;
    @Input() isTrailerRegNumber: boolean = false;
    @Input() tourId: number;

    regNumber: string;
    validationError: string = "";
    trailerRegNumber: string;
    transportOrderNumber: string | null = null;

    constructor(
        private formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<AddVehicleDialogComponent>,
        private cdr: ChangeDetectorRef,
        private actions$: Actions,
        @Inject(MAT_DIALOG_DATA) data: any,
        private store: Store
    ) {
        this.id = data.id;
        this.isEmail = data.isEmail;
        this.isCarrierEmail = data.isCarrierEmail;
        this.isTrailerRegNumber = data.isTrailerRegNumber;
        this.trailerRegNumber = data.trailerRegNumber;
        this.tourId = data.tourId;
        this.regNumber = data.email;
        this.transportOrderNumber = data.transportOrderNumber ?? null;
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    addClick() {
        // Validation: Only allow single registration number (no /, ;, ,)
        if (this.regNumber && /[\/;,]/.test(this.regNumber)) {
            this.validationError = "Please enter only a single vehicle/trailer registration number (no slashes, commas, or semicolons).";
            return;
        } else {
            this.validationError = "";
        }
        if (this.isEmail) {
            const sub1 = this.actions$
            .pipe(ofActionSuccessful(AddCustomerContactPersonSuccessAction))
            .subscribe((successAction: AddCustomerContactPersonSuccessAction) => {
                if(successAction){
                    this.store.dispatch(new GetTourByIdAction(this.id, this.transportOrderNumber));
                    this.dialogRef.close(true);
                }
                this.cdr.detectChanges();
                sub1.unsubscribe();
            });

            this.store.dispatch(new AddCustomerContactPersonAction(this.regNumber, this.id));

        } else if (this.isCarrierEmail) {
            const subCarrier = this.actions$
            .pipe(ofActionSuccessful(UpdateCarrierContactEmailSuccessAction))
            .subscribe((successAction: UpdateCarrierContactEmailSuccessAction) => {
                if(successAction){
                    this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));
                    this.dialogRef.close(true);
                }
                this.cdr.detectChanges();
                subCarrier.unsubscribe();
            });

            this.store.dispatch(new UpdateCarrierContactEmailAction(this.regNumber, this.tourId));

        } else if (this.isTrailerRegNumber) {
            const processedRegNumber = this.regNumber
                .replace(/\s+/g, "")
                .toUpperCase();
            const sub2 = this.actions$
            .pipe(ofActionSuccessful(AddTrailerRegByTourIdSuccessAction))
            .subscribe((successAction: AddTrailerRegByTourIdSuccessAction) => {
                if(successAction){
                    this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));
                    this.dialogRef.close(true);
                }
                this.cdr.detectChanges();
                sub2.unsubscribe();
            });
            this.store.dispatch(new AddTrailerRegByTourIdAction(this.id, processedRegNumber));
        } else {
            const processedRegNumber = this.regNumber
                .replace(/\s+/g, "")
                .toUpperCase();
            //vehicle amd tour id to auto assign
            this.store.dispatch(
                new AddVehicleAction(processedRegNumber, this.id)
            );
            this.dialogRef.close(true);
        }
    }
}
